import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FejlDashboardService } from '../fejl-dashboard.service';
import { FejlDashboardSubSummaryDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fejl-dashboard-sub-summary-dto';
import { MatTableDataSource } from '@angular/material/table';
import { FejlDashboardDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fejl-dashboard-dto';
import { MatSort, Sort } from '@angular/material/sort';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { FejlDashboardKanRetteFejlEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/fejl-dashboard-kan-rette-fejl-enum';
import { PaginationCacheService } from '../../../services/paginationcache.service';
import { FejlDashboardTypeEnum } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/fejl-dashboard-type-enum';
import { finalize, Subject, takeUntil, timer } from 'rxjs';
import { Router } from '@angular/router';
import { FejlDashboardSummaryDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fejl-dashboard-summary-dto';
import { Loader, LoaderService } from 'src/app/services/loader.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

interface ICheckedFejlDashboardDto {
  id: number;
  checked: boolean;
}

@Component({
    selector: 'app-fejl-dashboard-liste',
    templateUrl: './fejl-dashboard-liste.component.html',
    styleUrls: ['./fejl-dashboard-liste.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FejlDashboardListeComponent implements OnInit, OnDestroy {
  antalFejl: number = 0;

  createEftersynHaltedSummary: FejlDashboardSubSummaryDto = {
    fejlDashboardType: FejlDashboardTypeEnum.CreateEftersynHalted,
    antalFejl: null,
  };

  customerOpkraevningHaltedSummary: FejlDashboardSubSummaryDto = {
    fejlDashboardType: FejlDashboardTypeEnum.CustomerOpkraevningHalted,
    antalFejl: null,
  };

  fejletOrdreAfregningSummary: FejlDashboardSubSummaryDto = {
    fejlDashboardType: FejlDashboardTypeEnum.FejletOrdreAfregning,
    antalFejl: null,
  };

  fejletDannelseAfEftersynKreditstopSummary: FejlDashboardSubSummaryDto = {
    fejlDashboardType: FejlDashboardTypeEnum.FejletDannelseAfEftersynKreditstop,
    antalFejl: null,
  };

  fejletDannelseAfEftersynFlereEftersynSummary: FejlDashboardSubSummaryDto = {
    fejlDashboardType: FejlDashboardTypeEnum.FejletDannelseAfEftersynFlereEftersyn,
    antalFejl: null,
  };

  fejletOverfoerselSummary: FejlDashboardSubSummaryDto = {
    fejlDashboardType: FejlDashboardTypeEnum.FejletOverfoersel,
    antalFejl: null,
  };

  slutopgoerelserHaltedSummary: FejlDashboardSubSummaryDto = {
    fejlDashboardType: FejlDashboardTypeEnum.SlutopgoerelserHalted,
    antalFejl: null,
  };

  serviceintervallerSummary: FejlDashboardSubSummaryDto = {
    fejlDashboardType: FejlDashboardTypeEnum.Serviceintervaller,
    antalFejl: null,
  };

  postnummerUdenPartnerSummary: FejlDashboardSubSummaryDto = {
    fejlDashboardType: FejlDashboardTypeEnum.PostnummerUdenPartner,
    antalFejl: null,
  };

  afregningerHaltedSummary: FejlDashboardSubSummaryDto = {
    fejlDashboardType: FejlDashboardTypeEnum.AfregningerHalted,
    antalFejl: null,
  };

  summaries: FejlDashboardSubSummaryDto[] = [
    this.createEftersynHaltedSummary,
    this.customerOpkraevningHaltedSummary,
    this.fejletDannelseAfEftersynFlereEftersynSummary,
    this.fejletDannelseAfEftersynKreditstopSummary,
    this.fejletOrdreAfregningSummary,
    this.fejletOverfoerselSummary,
    this.serviceintervallerSummary,
    this.slutopgoerelserHaltedSummary,
    this.postnummerUdenPartnerSummary,
    this.afregningerHaltedSummary,
  ];

  dataSource: MatTableDataSource<FejlDashboardDto[]>;

  private allColumns: string[] = [
    'check',
    'produkt',
    'serviceordreNr',
    'okKundeNr',
    'okKundeAftaleNr',
    'partnerServiceProdukt',
    'postnummer',
    'partnerName',
    'beloeb',
    'scope',
    'fejlet',
    'fejl',
    'okKundeAnlaegAdresse',
    'slutDato',
    'action',
  ];
  displayedColumns: string[];
  @ViewChild(MatSort) sort: MatSort;
  private checklist: Array<ICheckedFejlDashboardDto> = [];

  localLoader: Loader;

  createEftersynHaltedLoader: Loader;
  customerOpkraevningHaltedLoader: Loader;
  fejletDannelseAfEftersynFlereEftersynLoader: Loader;
  fejletDannelseAfEftersynKreditstopLoader: Loader;
  fejletOrdreAfregningLoader: Loader;
  fejletOverfoerselLoader: Loader;
  serviceintervallerLoader: Loader;
  slutopgoerelserHaltedLoader: Loader;
  postnummerUdenPartnerLoader: Loader;
  afregningerHaltedLoader: Loader;

  unsubscribe$ = new Subject<void>();

  shouldShowChanged$: Subject<boolean>;

  showStateChanged: boolean;
  loadStateChanged: boolean;
  currentFejlDashboardType: FejlDashboardTypeEnum;

  get hasCheckedItems(): boolean {
    return !!this.checklist.find((p) => p.checked);
  }

  get button(): string {
    return this.service.button(this.checkedItemsCount);
  }

  get rowButton(): string {
    return this.service.button(null);
  }

  get checkedItemsCount(): number {
    return this.checklist.filter((p) => p.checked).length;
  }

  get activeSummaryAntalFejl(): number {
    return this.service.activeSummary.antalFejl;
  }

  constructor(
    navigation: PaginationCacheService,
    private service: FejlDashboardService,
    private router: Router,
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
  ) {
    this.localLoader = this.loader.createLoader({ delay: 300 });

    this.createEftersynHaltedLoader = this.service.createEftersynHaltedLoader;
    this.customerOpkraevningHaltedLoader = this.service.customerOpkraevningHaltedLoader;
    this.fejletDannelseAfEftersynFlereEftersynLoader = this.service.fejletDannelseAfEftersynFlereEftersynLoader;
    this.fejletDannelseAfEftersynKreditstopLoader = this.service.fejletDannelseAfEftersynKreditstopLoader;
    this.fejletOrdreAfregningLoader = this.service.fejletOrdreAfregningLoader;
    this.fejletOverfoerselLoader = this.service.fejletOverfoerselLoader;
    this.serviceintervallerLoader = this.service.serviceintervallerLoader;
    this.slutopgoerelserHaltedLoader = this.service.slutopgoerelserHaltedLoader;
    this.postnummerUdenPartnerLoader = this.service.postnummerUdenPartnerLoader;
    this.afregningerHaltedLoader = this.service.afregningerHaltedLoader;
    this.localLoader.showStateChanged$.subscribe((isShowing: boolean) => {
      this.showStateChanged = isShowing;
    });
    this.localLoader.loadingStateChanged$.subscribe((isLoading: boolean) => {
      this.loadStateChanged = isLoading;
    });

    service.subSummaryUpdated$.subscribe((subSummary: FejlDashboardSubSummaryDto) => {
      this.setsubSummary(subSummary);
    });

    service.summaryUpdated$.subscribe((summary: FejlDashboardSummaryDto) => {
      if (summary) {
        this.antalFejl = summary.antalFejl;

        summary.fejlDashboardTyper.forEach((subSummary: FejlDashboardSubSummaryDto) => {
          this.setsubSummary(subSummary);
        });
      }
    });

    this.displayedColumns = [...this.allColumns];

    const previousActive = FejlDashboardTypeEnum[navigation.position?.page];
    if (previousActive) {
      this.service.active = previousActive;
      this.showlist(this.service.activeSummary);
    }
  }

  ngOnInit(): void {
    this.service.summaryLoading$.subscribe((isLoading: boolean) => {
      isLoading ? this.loader.show() : this.loader.hide();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  setsubSummary(subSummary: FejlDashboardSubSummaryDto) {
    switch (subSummary?.fejlDashboardType) {
      case FejlDashboardTypeEnum.CustomerOpkraevningHalted:
        this.customerOpkraevningHaltedSummary = subSummary;
        break;
      case FejlDashboardTypeEnum.CreateEftersynHalted:
        this.createEftersynHaltedSummary = subSummary;
        break;
      case FejlDashboardTypeEnum.SlutopgoerelserHalted:
        this.slutopgoerelserHaltedSummary = subSummary;
        break;
      case FejlDashboardTypeEnum.Serviceintervaller:
        this.serviceintervallerSummary = subSummary;
        break;
      case FejlDashboardTypeEnum.FejletDannelseAfEftersynKreditstop:
        this.fejletDannelseAfEftersynKreditstopSummary = subSummary;
        break;
      case FejlDashboardTypeEnum.FejletDannelseAfEftersynFlereEftersyn:
        this.fejletDannelseAfEftersynFlereEftersynSummary = subSummary;
        break;
      case FejlDashboardTypeEnum.FejletOverfoersel:
        this.fejletOverfoerselSummary = subSummary;
        break;
      case FejlDashboardTypeEnum.FejletOrdreAfregning:
        this.fejletOrdreAfregningSummary = subSummary;
        break;
      case FejlDashboardTypeEnum.PostnummerUdenPartner:
        this.postnummerUdenPartnerSummary = subSummary;
        break;
      case FejlDashboardTypeEnum.AfregningerHalted:
        this.afregningerHaltedSummary = subSummary;
      default:
    }
  }

  showlist(event: FejlDashboardSubSummaryDto) {
    this.dataSource = new MatTableDataSource<FejlDashboardDto[]>();
    this.currentFejlDashboardType = event.fejlDashboardType;

    this.localLoader.start();

    this.service
      .hentList(event.fejlDashboardType)
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => {
          this.localLoader.stop();
        }),
      )
      .subscribe(
        (data: FejlDashboardDto[]) => {
          this.displayedColumns = [...this.allColumns];

          if (this.currentFejlDashboardType != FejlDashboardTypeEnum.PostnummerUdenPartner) {
            if (this.currentFejlDashboardType != FejlDashboardTypeEnum.AfregningerHalted) {
              this.displayedColumns.splice(8, 2);
              if (!data.filter((p) => !!p.terminationDate).length) {
                this.displayedColumns.splice(11, 1); //no terminationdate in list
              }
              if (!data.filter((p) => !!p.partnerName).length) {
                this.displayedColumns.splice(7, 1); //no partnername in list
              }
              if (!data.filter((p) => !!p.serviceordreNr).length) {
                this.displayedColumns.splice(2, 1); //ingen ordrenumre i listen
                this.displayedColumns.splice(4, 2);
              } else {
                this.displayedColumns.splice(5, 2);
              }
            } else {
              this.displayedColumns.splice(0, 1);
              this.displayedColumns.splice(2, 1);
              this.displayedColumns.splice(3, 3);
              this.displayedColumns.splice(8, 1);
            }
          } else {
            this.displayedColumns.splice(0, 5);
            this.displayedColumns.splice(3, 2);
            this.displayedColumns.splice(5, 2);
          }

          if (this.service.activeSummary.kanRetteFejl != FejlDashboardKanRetteFejlEnum.Flere) {
            this.displayedColumns.shift(); // ingen checkbox
          }
          this.dataSource = new MatTableDataSource<any>(data);

          this.checklist = data.map((p) => {
            return { id: p.id, checked: false };
          });
        },
        (error) => {
          this.errorHandler.HandleError(error);
        },
      );
  }
  sortData(sort: Sort) {
    this.dataSource.sort = this.sort;
  }

  onRowClick(row: FejlDashboardDto) {
    if (
      this.service.activeSummary.kanRetteFejl == FejlDashboardKanRetteFejlEnum.Nej ||
      this.currentFejlDashboardType == FejlDashboardTypeEnum.PostnummerUdenPartner
    ) {
      this.openPage(row);
    } else this.retEnFejl(row);
  }

  openPage(row: FejlDashboardDto) {
    if (row.serviceordreNr && row.fejlDashboardType != FejlDashboardTypeEnum.AfregningerHalted) {
      this.router.navigate(['/ordre', row.serviceordreNr, 'edit', { page: this.service.active }]);
    } else if (row.partnerServiceProdukt) {
      this.router.navigate(['/indstillinger'], {
        fragment: 'postnummer',
        queryParams: { postnummer: row.postnummer, produkt: row.partnerServiceProdukt },
      });
    } else {
      this.router.navigate(['/aftale', row.okKundeAftaleNr, { page: this.service.active }]);
    }
  }

  onCheckChange(event: MatCheckboxChange, id) {
    if (!id) {
      this.checklist.forEach((p) => (p.checked = event.checked));
    } else this.checklist.find((p) => p.id == id).checked = event.checked;
  }

  isChecked(id): boolean {
    return this.checklist.find((p) => p.id == id).checked;
  }

  // kald backend for at få relevant handler til at håndtere fejl
  async retFlereFejl() {
    var data = this.checklist.filter((p) => p.checked);
    await this.service.retFejl(data);
    await timer(500).subscribe((p) => {
      this.showlist({ fejlDashboardType: this.service.active });
    });
  }

  async retEnFejl(row: FejlDashboardDto) {
    await this.service.retFejl([row]);
    await this.showlist({ fejlDashboardType: this.service.active });
  }
}
